module.exports = "<a ng-show=\"isIFrame\" href=\"{{redirectURL}}\" id=\"closeButton\" target=\"_parent\" role=\"button\" ng-click=\"closeFrame($event)\">{{ content('base.closePayPalCheckoutLabel') }}</a>\n"


/*****************
 ** WEBPACK FOOTER
 ** ../~/noop-loader!./components/xo-ui-components/src/escape-hatch/closeFrame/template.html
 ** module id = 501
 ** module chunks = 1
 **/